export const getPerimeterTypes = (state) => state.types